/* global moment toastr $ flatpickr */

import { request } from "../lib/utils";
import { load_choice } from "../choice/utils";
import {Tooltip} from "../lib/components"
import React, { Component } from "react";
import { connect } from "react-redux";


class DateInput extends Component {
  constructor(props) {
    super(props);
    this.ref_input = React.createRef();
    this.state = { localInput: null };
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    const that = this;
    var input = that.ref_input.current;

    that._fp = flatpickr(input, {
      dateFormat: "d.m.Y",
      allowInput: true,
      locale: "ru",
      onClose: () => { that.onBlur(); }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.state.localInput !== null) {
      this.setState({ localInput: null });
    }
  }

  componentWillUnmount() {
    if (this._fp) this._fp.destroy();
  }

  onChange(e) {
    const value = e.target.value.trim();
    if (value === "") {
      this.props.onChange(this.props.name, undefined);
      this.setState({ localInput: null });
      return;
    }
    const m = moment(value, "DD.MM.YYYY", true);
    if (m.isValid()) {
      this.props.onChange(this.props.name, m.format("YYYY-MM-DD"));
      this.setState({ localInput: null });
    } else {
      this.setState({ localInput: value });
    }
  }

  onBlur() {
    if (this.state.localInput === null) return;
    const value = this.state.localInput.trim();
    if (value === "") {
      this.setState({ localInput: null });
      return;
    }
    const m = moment(value, "DD.MM.YYYY", true);
    if (m.isValid()) {
      this.props.onChange(this.props.name, m.format("YYYY-MM-DD"));
    }
    this.setState({ localInput: null });
  }

  render() {
    const props = this.props;
    const displayValue = this.state.localInput !== null
      ? this.state.localInput
      : (props.value ? moment(props.value, "YYYY-MM-DD").format("DD.MM.YYYY") : "");

    return (
      <input
        type="text"
        className="form-control"
        name={props.name}
        onChange={this.onChange}
        onInput={this.onChange}
        onBlur={this.onBlur}
        ref={this.ref_input}
        value={displayValue}
        disabled={props.disabled}
        autoComplete="off"
      />
    )
  }
}

class DateRange extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
  }

  get value() {
    return this.props.value || {}
  }

  onChange(name, value) {
    let new_data = { ...this.value}

    // Вырезаем из объекта пустые аттрибуты
    if(value === undefined) {
      delete new_data[name]
    }
    else {
      new_data[name] = value
    }

    // Если в объекте ничего не осталось, то и никакого объекта нет
    if(Object.keys(new_data).length === 0) {
      new_data = undefined
    }

    this.props.onChange(this.props.name, new_data)
  }

  render() {
    const props = this.props

    return (
      <div className="input-group">
        <DateInput
          name="from"
          value={this.value.from || ""}
          disabled={props.disabled}
          onChange={this.onChange}
          onInput={this.onChange}
        />
        <DateInput
          name="to"
          value={this.value.to || ""}
          disabled={props.disabled}
          onChange={this.onChange}
          onInput={this.onChange}
        />
      </div>
    )
  }
}

class FloatRange extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
  }

  get value() {
    return this.props.value || {}
  }

  onChange(event) {
    const name = event.target.name;
    const value = event.target.value ? parseFloat(event.target.value) : null
    this.props.onChange(this.props.name, { ...this.value, [name]: value })
  }

  render() {
    const props = this.props

    return (
      <div className="input-group">
        <input
          type="number"
          name="from"
          value={this.value.from || ""}
          disabled={props.disabled}
          onChange={this.onChange}
          className="form-control"
        />
        <input
          type="number"
          name="to"
          value={this.value.to || ""}
          disabled={props.disabled}
          onChange={this.onChange}
          className="form-control"
        />
      </div>
    )
  }
}

class DateTimeInput extends Component {
  constructor(props) {
    super(props);
    this.ref_input = React.createRef();
    this.state = { localStr: null };
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.commitLocalValue = this.commitLocalValue.bind(this);
  }

  // Конвертирует значение между форматом ISO и форматом отображения
  formatValue(value, direction) {
    if (!value) return "";
    if (direction === "in") return moment(value).format("DD.MM.YYYY HH:mm:ss");
    if (direction === "out") return moment(value, "DD.MM.YYYY HH:mm:ss").format();
  }

  parseValue(str) {
    if (!str || !String(str).trim()) return undefined;
    const formats = ["DD.MM.YYYY HH:mm:ss", "DD.MM.YYYY HH:mm", "DD.MM.YYYY"];
    for (const fmt of formats) {
      const m = moment(str, fmt, true);
      if (m.isValid()) return m.format();
    }
    return undefined;
  }

  commitLocalValue() {
    if (this.state.localStr === null) return;
    const parsed = this.parseValue(this.state.localStr);
    if (parsed !== undefined) {
      this.props.onChange(this.props.name, parsed);
      this.setState({ localStr: null });
    }
  }

  onChange(e) {
    const str = e.target.value;
    this.setState({ localStr: str });
    const parsed = this.parseValue(str);
    if (parsed !== undefined) this.props.onChange(this.props.name, parsed);
  }

  onBlur() {
    this.commitLocalValue();
  }

  onKeyDown(e) {
    if (e.key === "Enter") {
      this.commitLocalValue();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.localStr !== null && this.props.value !== prevProps.value) {
      this.setState({ localStr: null });
    }
  }

  componentDidMount() {
    var input = this.ref_input.current;
    flatpickr(input, {
      enableTime: true,
      dateFormat: "d.m.Y H:i:S",
      allowInput: true,
      locale: "ru"
    });
  }

  render() {
    const props = this.props;
    const displayValue = this.state.localStr !== null
      ? this.state.localStr
      : this.formatValue(props.value || "", "in");

    return (
      <input
        type="text"
        className="form-control"
        name={props.name}
        onChange={this.onChange}
        onInput={this.onChange}
        onBlur={this.onBlur}
        onKeyDown={this.onKeyDown}
        ref={this.ref_input}
        value={displayValue}
        disabled={props.disabled}
        autoComplete="off"
      />
    );
  }
}

class DateTimeRange extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
  }

  get value() {
    return this.props.value || {}
  }

  onChange(name, value) {
    this.props.onChange(this.props.name, { ...this.value, [name]: value })
  }

  render() {
    const props = this.props

    return (
      <div className="input-group">
        <DateTimeInput
          name="from"
          value={this.value.from || ""}
          disabled={props.disabled}
          onChange={this.onChange}
        />
        <DateTimeInput
          name="to"
          value={this.value.to || ""}
          disabled={props.disabled}
          onChange={this.onChange}
        />
      </div>
    )
  }
}

class TableInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.addRow = this.addRow.bind(this);
  }

  onChange(rowIdx, name, value) {
    let table_value = [...this.props.value];
    table_value[rowIdx] = { ...table_value[rowIdx], [name]: value };
    this.props.onChange(this.props.name, table_value);
  }

  addRow() {
    let table_value = [...(this.props.value || [])];
    table_value.push({ id: 0 });
    this.props.onChange(this.props.name, table_value);
  }

  removeRow(rowIdx) {
    let table_value = [...(this.props.value || [])];
    table_value.splice(rowIdx, 1);
    this.props.onChange(this.props.name, table_value);
  }

  render() {
    let that = this;
    const access = this.props.access;
    const attrs = this.props.inner_attrs;
    const table_value = this.props.value || [];
    const rows_messages = this.props.message || {}
    const errors = this.props.error || {}

    // Определяемся с набором колонок, которые мы будем выводить в таблице
    // Определяем их по первой строке. Пока пусть так будет
    let columns = [];
    for (const attr_name in access[0]) {
      const attr = attrs[attr_name];
      if (attr !== undefined) {
        columns.push(attr);
      }
    }

    // Эта функция сделана изолированной, так как может быть переопределена
    // и очень важно, чтобы все нужные для этого параметры могли быть получены через аргументы
    let renderTd;
    if (this.props.renderTd !== undefined) {
      renderTd = this.props.renderTd
    }
    else {
      renderTd = (row_idx, attr, access, row_data, table_component) => {
        const value = row_data[attr.name];
        const row_messages = rows_messages[row_data.id] || {} // {123: {col_1: "", col_2: "", "__row__": ""}}
        const row_errors = errors[row_data.id] || {}

        return (
          <td key={attr.name}>
            <AttrInput
              input_in_td={true}
              data_type={attr.data_type}
              name={attr.name}
              inner_attrs={attr.inner_attrs}
              value={value}
              choice_name={attr.choice_name}
              message={row_messages[attr.name]}
              error={row_errors[attr.name]}
              access={access}
              onChange={(name, value) => {
                table_component.onChange(row_idx, name, value);
              }}
            />
          </td>
        );
      }
    }

    function renderRow(row_data, row_idx) {
      const row_access = access[row_data.id];

      const row_messages = rows_messages[row_data.id] || {} // {con1: "", col2: "", "__row__": ""}
      const row_message = row_messages["__row__"]
      const row_error = errors[row_data.id]?.["__row__"] // {con1: "", col2: "", "__row__": ""}

      return (
        <tr key={row_idx}>
          {columns.map((attr) => {
            const col_access = row_access[attr.name];
            return renderTd(row_idx, attr, col_access, row_data, that);
          })}
          <td key="manage" className='d-flex justify-content-end align-items-center gap-1'>
            {row_message && <Tooltip message={row_message} placement={'left'}/>}
            { row_error && 
              <Tooltip message={row_error} icon_class={'ti ti-exclamation-circle'} class_name={'text-danger'} placement='left' />
            }

            {row_access.can_delete && (
              <span
                className="btn btn-icon btn-sm btn-secondary waves-effect waves-light"
                onClick={() => {
                  that.removeRow(row_idx);
                }}
              >
                <span className="ti ti-backspace"></span>
              </span>
            )}
          </td>
        </tr>
      );
    }

    return (
      <div>
        {table_value.length > 0 && (
          <table className="tableinput mb-1">
            <thead>
              <tr>
                {columns.map((attr) => {
                  return (
                    <th key={attr.name} className="text-center">
                      {attr.title}
                    </th>
                  );
                })}
                <th key="manage"/>
              </tr>
            </thead>
            <tbody className="table-border-bottom-0">
              {table_value.map(renderRow)}
            </tbody>
          </table>
        )}
        {access[0].can_create && (
          <span className="btn btn-outline-primary waves-effect btn-xs px-2 ps-1" onClick={this.addRow}>
            <i className="ti ti-plus ti-xs me-1"></i> Добавить
          </span>
        )}
      </div>
    );
  }
}


/**
 * tags: boolean
 * multiple: boolean
 * name: str
 * value: str | list[str]
 * access: edit | read
 * choice_items: list[str, str]
 * onChange: callable(str, str | list[str])
 */
export class Select2Input extends Component {

  constructor(props) {
    super(props)
    this.ref_input = React.createRef()
  }

  componentDidMount() {
    const that = this
    const ref_input_jq = $(this.ref_input.current)

    // Определяем, поверх чего рисовать выпадающий список, если input внутри модалки
    let dropdownParent = $("body");

    if (ref_input_jq.parents('.modal:first').length !== 0) {
      dropdownParent = ref_input_jq.closest('.modal');
    }

    ref_input_jq.select2({
      tags: this.props.tags,
      dropdownParent: dropdownParent,
    }).on('change', function (event) {
      that.props.onChange(event)
    })
  }

  componentDidUpdate(prevProps) {
    // Если value изменилось, заставляем перерисовываться, на случай,
    // если оно изменилось снаружи
    if (this.props.value !== prevProps.value) {
      $(this.ref_input.current).trigger('change.select2');
    }
  }

  render() {
    if (this.props.choice_items) {
      return (
        <select
          className="form-control"
          multiple={this.props.multiple}
          name={this.props.name}
          // defaultValue={this.props.value}
          value={this.props.value || ""}
          onChange={() => {
            // Ничего не делаем, все и так выполняет .on('change', ...), которая навешалась в componentDidMount
          }}
          disabled={this.props.disabled}
          ref={this.ref_input}>
          {this.props.choice_items.map((item) => {
            return (
              <option key={item[0]} value={item[0]}>
                {item[1]}
              </option>
            );
          })}
        </select>
      )
    }

    return <span>Загрузка опций...</span>

  }

}


class SummernoteInput extends Component {

  constructor(props) {
    super(props)
    this.ref_input = React.createRef()
  }

  componentDidMount() {
    const that = this

    $(this.ref_input.current).summernote({
      height: this.props.height || 200,
      toolbar: this.props.toolbar || [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']]
      ]
    }).on('summernote.change', function (we, contents, $editable) {
      that.props.onChange(that.props.name, contents)
    });
  }

  componentWillUnmount() {
    $(this.ref_input.current).summernote('destroy');
  }

  render() {
    return <textarea name={this.props.name}
      placeholder={this.props.placeholder}
      disabled={this.props.disabled}
      onChange={this.props.onChange}
      value={this.props.value || ""}
      ref={this.ref_input} />
  }
}

class NumberInput extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      hasBlurEvent: false,
      displayValue: this.formatDisplayValue(props.value, this.props.widget) ?? ""
    };
  }

  formatDisplayValue = (value, separatedType) => {
    /* Функция для форматирования числа по разрядам с использованием определенных сепараторов */

    if (!value && value !== 0) return "";
    let displayValue;

    /* Если значение уже число, используем его, иначе парсим */
    if (typeof value === 'number') {
      displayValue = value;
    } else {
      displayValue = parseFloat(value);
    }

    if (isNaN(displayValue)) return "";

    if (separatedType == "space-separated") { displayValue = displayValue.toLocaleString('ru-RU')}
    else if (separatedType == "dot-separated") { displayValue = displayValue.toLocaleString('de-DE')}
    else if (separatedType == "comma-separated") { displayValue = displayValue.toLocaleString('en-US')}
    else if (separatedType == "underscore-separated") { displayValue = displayValue.toLocaleString('de-DE').replaceAll(".", "_")}

    return displayValue
  };

  onChange(event){
    this.setState({
      hasBlurEvent: false,
      displayValue: event.target.value.replace(/[^0-9-.,_ ]/gi, "")
    })
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      /* Обновляем displayValue при изменении props.value */
      if (!this.state.hasBlurEvent) {
        const formattedValue = this.formatDisplayValue(this.props.value, this.props.widget) ?? "";
        /* Проверяем, что новое значение действительно отличается от текущего displayValue
        (без этого будет бесконечный перерендер) */
        if (formattedValue !== this.state.displayValue) {
          this.setState({
            displayValue: formattedValue
          });
        }
      }
    }
  }

  onBlur = () => {
    const { dataType, name, widget } = this.props;
    const { displayValue } = this.state;

    let inputValue = displayValue ?? "";

    /* Приводим к строке для проверки на пустоту */
    const inputValueStr = inputValue.toString();
    if (inputValue === null || inputValue === undefined || inputValueStr.trim() === "") {
      /* Если поле пустое, очищаем и устанавливаем пустое значение */
      this.props.onChange({ target: { name: name, value: "" } });
      this.setState({ hasBlurEvent: true, displayValue: "" });
      return;
    }

    /* Приводим к строке для обработки */
    let processedValue = inputValue.toString();

    if (dataType == "integer") {
      processedValue = processedValue.replace(/[^0-9-]/gi, "");
      /* Убираем лишние тире */
      if (processedValue.includes("-") && !processedValue.startsWith("-")) {
        processedValue = processedValue.replace("-", "");
      }
      /* Конвертируем в число, если возможно */
      processedValue = processedValue === "" ? "" : parseInt(processedValue);

    } else if (["float", "decimal"].includes(dataType)) {
      /* replacer - конструкция замыкания, позволяющая вернуть только символ под определенным индексом,
        заменив остальные на пустую строку */
      const replacer = (counter) => (char) => !counter++ ? char : "";

      /* Из начального значения:
          1. Удаление всех символов кроме чисел, тире, точки, запятой
          2. Удаление всех тире кроме 1-го
          3. Замена всех запятых на точки
          4. Удаление всех точек кроме первой */
      processedValue = processedValue
        .replace(/[^0-9-.,]/gi, "")
        .replace(/-/g, replacer(0))
        .replace(/,/g, ".")
        .replace(/\./g, replacer(0));

      if (processedValue.includes("-") && !processedValue.startsWith("-")){
        /* Убираем тире если оно находится не в начале.
          Если есть более 1-го тире и одно из них в начале,
          то лишние тире будут убраны при использовании ParseFloat() */
        processedValue = parseFloat(processedValue.replace("-", ""))
      } else {
        /* Конвертируем в число, если возможно */
        processedValue = processedValue === "" ? "" : parseFloat(processedValue);
      }
    }

    /* Передаем значение в onChange только если оно изменилось */
    if (processedValue !== this.props.value) {
      this.props.onChange({ target: { name: name, value: processedValue } });
    }

    const formattedValue = this.formatDisplayValue(processedValue, widget) ?? "";
    /* Обновляем state только если displayValue действительно изменилось
    (без этого будет бесконечный перерендер) */
    if (formattedValue !== this.state.displayValue) {
      this.setState({ hasBlurEvent: true, displayValue: formattedValue });
    } else {
      this.setState({ hasBlurEvent: true });
    }
  };

  render(){
    const {name, disabled} = this.props;
    const { displayValue } = this.state;

    return (
      <input
        type="text"
        className="form-control"
        name={name}
        onChange={this.onChange}
        onBlur={this.onBlur}
        value={displayValue}
        disabled={disabled}
        autoComplete="off"
      />
    )
  };
}


class InputRaw extends Component {
  constructor(props) {
    super(props);

    this.state = {
      choice_items: undefined,
    };

    this.updateChoice = this.updateChoice.bind(this);
    this.onChange = this.onChange.bind(this);
    this.update_choice_in_work = false;
  }

  componentDidUpdate(prevProps) {
    // У полей, которые запрашивают опции себе сами, при изменении контекста, перезапросить опции
    if (
      this.props.choice_name !== undefined &&
      JSON.stringify(this.props.choice_context) !==
      JSON.stringify(prevProps.choice_context)
    ) {
      this.updateChoice();
    }
  }

  getChoiceItems() {
    let choice_items
    const value = this.props.value

    // Опции переданы в компонент в готовом виде
    if (this.props.choice_items !== undefined) {
      choice_items = this.props.choice_items;
    }

    // Опции с контекстом компонент для себя запрашивает сам и хранит в state
    else if (this.props.choice_context) {
      choice_items = this.state.choice_items;
    }

    // Опции без контекста берем из redux
    else {
      choice_items = this.props.choices[this.props.choice_name];
    }

    // Просматриваем опции и ищем, есть ли в них значение, которое по факту выбрано в value.
    // Если отсутствует, добавляем принудительно, чтобы в GUI отображалось
    const value_array = Array.isArray(value)

    if(choice_items && (value_array && value.length > 0 || !value_array && value)) {
      const lost_values = new Set(value_array ? value : [value])  // Считаем, что все выбранные записи не найдены в choice_items

      // Убираем запись из потерянных, если значение найдено в choice_items
      choice_items.forEach(item => {
        const item_value = item[0]
        if(lost_values.has(item_value)) {
          lost_values.delete(item_value)
        }
      })

      // Если у нас остались значения, которые выбраны, но в choice_items их нет, то добавляем в choice_items
      if (lost_values.size > 0) {
        choice_items = [...choice_items]  // Копия

        lost_values.forEach(current_value => {
          choice_items.push([current_value, current_value])
        })
      }
    }

    return choice_items
  }

  onChange(event) {
    const data_type = this.props.data_type;
    const name = event.target.name;
    const options = event.target.options;

    let value

    if (data_type === "boolean") {
      value = event.target.checked;
    }
    else {
      value = event.target.value;
    }

    if (["m2m_string", "m2m_integer"].includes(data_type)) {
      value = [];

      let value_item;
      for (var i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) {
          value_item = options[i].value;
          if (data_type === "m2m_integer") {
            value_item = parseInt(value_item);
          }
          value.push(value_item);
        }
      }
    }

    if (this.props.data_type === "integer")
      value = value === "" || isNaN(parseInt(value)) ? null : parseInt(value);

    this.props.onChange(name, value);
  }

  updateChoice() {
    let that = this;
    const choice_name = this.props.choice_name;

    // Кастомные опции хранятся в state этого компонента
    if (that.props.choice_context) {
      if (this.update_choice_in_work) {
        return;
      }

      this.update_choice_in_work = true;

      request({
        method: "post",
        url: "/api/choice/items",
        data: {
          name: choice_name,
          context: that.props.choice_context,
          current_value: this.props.value,
        },
        success: (data) => {
          that.setState({ choice_items: data }, () => {
            that.update_choice_in_work = false;
          });
        },
        error: (data) => {
          toastr.error(data);
          that.update_choice_in_work = false;
        },
      });
    }

    // Стандартные опции после получения отправляются в redux
    else {
      load_choice(choice_name);
    }
  }

  render() {
    let props = this.props;
    let choice_items = this.getChoiceItems();
    const data_type = props.data_type;
    const access = props.access
    const autocomplete = props.enable_autocomplete ? "on" : "off"

    // Если требуются опции, но они пока не пришли
    if (props.choice_name && (choice_items === undefined || choice_items === null)) {
      this.updateChoice();
      return <div>Загружается...</div>;
    }

    if (data_type === "summernote") {
      return <SummernoteInput
        name={props.name}
        value={props.value}
        disabled={access === "read"}
        onChange={props.onChange}
      />
    }

    if (data_type === "date_range") {
      return <DateRange
        name={props.name}
        value={props.value}
        disabled={access === "read"}
        onChange={props.onChange}
      />
    }

    if (data_type === "float_range") {
      return <FloatRange
        name={props.name}
        value={props.value}
        disabled={access === "read"}
        onChange={props.onChange}
      />
    }

    if (data_type === "datetime_range") {
      return <DateTimeRange
        name={props.name}
        value={props.value}
        disabled={access === "read"}
        onChange={props.onChange}
      />
    }

    if (["integer", "string"].includes(data_type) && choice_items) {
      if(props.widget === "select2") {
        choice_items = [['', '----'], ...choice_items]
        return <Select2Input
          name={props.name}
          value={props.value || ''}
          disabled={access === "read"}
          onChange={this.onChange}
          multiple={false}
          choice_items={choice_items}
          tags={ props.tags }
        />
      }
      else {
        let title = ""
        try{
          title = choice_items.find(item => item[0] === props.value)?.[1]
        }
        catch(e){
          console.error(e.message)
        }

        return (
          <select
            className="form-select"
            name={props.name}
            value={props.value || ""}
            disabled={access === "read"}
            onChange={this.onChange}
            title={title}
          >
            <option key="blank" value="">----</option>
            {choice_items.map((item) => {
              return (
                <option key={item[0]} value={item[0]}>{item[1]}</option>
              );
            })}
          </select>
        );
      }
    }

    if (["m2m_string", "m2m_integer"].includes(data_type)) {
      return <Select2Input
        name={props.name}
        value={props.value || []}
        disabled={access === "read"}
        onChange={this.onChange}
        multiple={true}
        choice_items={choice_items}
      />
    }

    if (data_type === "text" || props.widget === 'textarea') {
      return (
        <textarea
          type="text"
          rows={props.rows}
          className="form-control"
          placeholder={props.placeholder}
          name={props.name}
          value={props.value || ""}
          disabled={access === "read"}
          onChange={this.onChange}
          autoComplete={autocomplete}
        />
      );
    }

    if (data_type == "string") {
      return <input
        type="text"
        disabled={access === "read"}
        className="form-control"
        placeholder={props.placeholder}
        name={props.name}
        title={props.value}
        value={props.value === null ? "" : props.value}
        onChange={this.onChange}
        autoComplete={autocomplete}
      />
    }

    if (["integer", "decimal", "float"].includes(data_type)) {
      return <NumberInput
        type="text"
        disabled={access === "read"}
        className="form-control"
        placeholder={props.placeholder}
        name={props.name}
        title={undefined}
        value={props.value === null ? "" : props.value}
        onChange={this.onChange}
        autoComplete={autocomplete}
        dataType={data_type}
        widget={props.widget}
      />
    }

    if (data_type === "time") {
      return (
        <input
          type="text"
          disabled={access === "read"}
          className="form-control"
          placeholder={props.placeholder}
          name={props.name}
          value={props.value || ""}
          onChange={this.onChange}
          autoComplete={autocomplete}
        />
      );
    }

    if (data_type === "property") {
      return <div className="form-control">{props.value}</div>
    }

    if (props.data_type === "datetime") {
      return (
        <DateTimeInput
          placeholder={props.placeholder}
          name={props.name}
          value={props.value}
          disabled={access === "read"}
          onChange={props.onChange}
        />
      );
    }

    if (props.data_type === "date") {
      return (
        <DateInput
          placeholder={props.placeholder}
          name={props.name}
          value={props.value}
          disabled={access === "read"}
          onChange={props.onChange}
          autocomplete={autocomplete}
        />
      );
    }

    if (props.data_type === "password") {
      return (
        <input
          type="password"
          className="form-control"
          placeholder={props.placeholder}
          name={props.name}
          value={props.value || ""}
          disabled={access === "read"}
          onChange={this.onChange}
          autoComplete={autocomplete}
        />
      );
    }

    if (props.data_type === "boolean") {
      return (
        <div className="form-check form-switch mb-2 pt-2" key={props.name}>
          <input
            className="form-check-input"
            type="checkbox"
            name={props.name}
            checked={props.value || false}
            disabled={access === "read"}
            onChange={this.onChange}
          />
        </div>
      )
    }

    if (props.data_type === "table" && props.inner_attrs) {
      return <TableInput {...props} />;
    }

    return <div>{props.data_type}</div>;
  }
}

export let Input = connect((state) => {
  return { choices: state.choice.choices };
})(InputRaw);

/**
 * Универсальный элемент формы ввода, который отображается по разному,
 * в зависимости от типа данных вместе с названием поля (label)
 * и принимает параметры:
 * - data_type (
 *      bool,
 *      integer, float, decimal,
 *      string, password, text, html,
 *      date, datetime, date_range,
 *      property, m2m_string, m2m_integer, table,
 *  )
 * - name
 * - inner_attrs
 * - title
 * - value
 * - choice_name
 * - choice_context
 * - choice_items
 * - message
 * - access
 * - onChange
 * - placeholder
 * - enable_autocomplete
 */
export default class AttrInput extends Component {

  // Для возможности подставить кастомный input
  renderInput() {
    return <Input {...this.props}/>
  }

  renderMessageTooltip() {
    if (this.props.message && typeof this.props.message === 'string') {
      return <Tooltip message={this.props.message}/>
    }
  }

  renderError() {
    if (this.props.error && this.props.data_type !== "table") {
      return <div key="error" className="text-danger">{this.props.error}</div>
    }
  }

  render() {
    const props = this.props;

    // input внутри ячейки таблицы отрисовываем только с ошибками и инфо-сообщениями
    if (props.input_in_td === true) {
      // Если с отображением input + tooltip + errors будут проблемы, вернемся к этому закомментированному коду
      // return [
      //   <div className='d-flex align-items-center'>
      //     {this.renderInput()}
      //     {this.renderMessage()}
      //   </div>,
      //   this.renderError()
      // ]
      return [
        this.renderInput(),
        this.renderMessageTooltip(),
        this.renderError(),
      ]
    }

    if (props.horizontal) {
      return (
        <div className="row mb-1">
          {props.title && (
            <label className="col-md-6 text-right col-form-label">
              {props.title} { this.renderMessageTooltip() }
            </label>
          )}
          <div className="col-md-6">
            {this.renderInput()}
            {this.renderError()}
          </div>
        </div>
      )
    }

    return (
      <div className="form-group">
        {props.title && (
          <label className="form-label">{props.title} { this.renderMessageTooltip() }</label>
        )}
        {this.renderInput()}
        {this.renderError()}
      </div>
    );
  }
}
